// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const reportsApi = baseApi.injectEndpoints({
  // reducerPath: "reportsApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllReports: builder.query({
      query: (query) => {
        const queryString = new URLSearchParams(query).toString();
        return {
          url: `report`,
          params: queryString,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    updateResolveStatus: builder.mutation({
      query: ({ slug, data }) => {
        return {
          url: `report/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllReportsQuery, useUpdateResolveStatusMutation } =
  reportsApi;
